import DataSource from './DataSource';
import DataModel from './DataModel';

const DataAttributes = ['id', 'name', 'sex', 'breed_id',
  'country_id', 'pedigree', 'date_of_birth', 'color', 
  'titles', 'owner_name', 'owner_email', 'owner_phone', 
  'breeder_name', 'father_name', 'mother_name', 'register_to',
  'need_catalog',
  ];

const Defaults = () => ({
  id: '',
  name: '',
  sex: '',
  breed_id: null,
  pedigree: '',
  date_of_birth: '',
  color: '',
  titles: '',
  owner_name: '',
  owner_email: '',
  owner_phone: '',
  breeder_name: '',
  father_name: '',
  mother_name: '',
  need_catalog: false,
  registerTo: [],
});

export default class RegistrationRequest extends DataModel {
  static Defaults = Defaults;
  static DataAttributes = DataAttributes;
  static resource = DataSource.getSource('registration_requests', 'registration_requests{/:id}.json', 'registration_request');

  constructor(data) {
    super(data);
    this.updateFrom({...this.constructor.Defaults(), ...data});
    if (this.date_of_birth) {
      this.date_of_birth = new Date(Date.parse(this.date_of_birth));
    } else {
      this.date_of_birth = null;
    }
  }

}

